import React from 'react';
import PropTypes from 'prop-types';
import styles from './SbSharedPagination.scss';
import pageLinks from 'dibs-pagelinks';

import { SbSharedPaginationArrow } from './SbSharedPaginationArrow';
import { SbSharedPaginationSeparator } from './SbSharedPaginationSeparator';
import { SbSharedPaginationItem } from './SbSharedPaginationItem';

import tracking from 'dibs-tracking';

const scrollUp = () => {
    window.scroll(0, 0);
};

const trackPaginationClick = (pageClicked, numberOfPages) => {
    tracking.trackEvent({
        category: 'navigation',
        action: 'pagination page number clicked',
        label: `${pageClicked}/${numberOfPages}`,
    });
};

const handlePaginationClick = (pageClicked, numberOfPages) => {
    scrollUp();

    trackPaginationClick(pageClicked, numberOfPages);
};

const SbSharedPagination = ({ uriRef, currentPage, numberOfPages, totalPageLinks }) => {
    const pageLinksInfo = pageLinks(numberOfPages, currentPage, totalPageLinks);
    const PaginationItems = pageLinksInfo.map(({ type, key, pageNumber, isSelected }) => {
        let paginationItem;
        if (type === 'back' || type === 'forward') {
            const isLeft = type === 'back';
            const isRight = type === 'forward';
            //arrrow
            paginationItem = (
                <SbSharedPaginationArrow
                    uriRef={uriRef}
                    currentPage={currentPage}
                    onClick={() => handlePaginationClick(pageNumber, numberOfPages)}
                    isLeft={isLeft}
                    isRight={isRight}
                    key={key}
                    dataTn={`page-${type}`}
                />
            );
        } else if (type === 'ellipsis') {
            //separator
            paginationItem = <SbSharedPaginationSeparator key={key} />;
        } else if (type === 'page') {
            //pagination item
            paginationItem = (
                <SbSharedPaginationItem
                    uriRef={uriRef}
                    index={pageNumber}
                    onClick={() => handlePaginationClick(pageNumber, numberOfPages)}
                    isLast={pageNumber === numberOfPages}
                    isSelected={isSelected}
                    key={key}
                />
            );
        }

        return paginationItem;
    });

    if (numberOfPages > 1) {
        return (
            <div className={styles.pagination}>
                <ul
                    className={styles.paginationList}
                    data-tp={numberOfPages}
                    data-tn="pagination-list"
                >
                    {PaginationItems}
                </ul>
            </div>
        );
    } else {
        return null;
    }
};

SbSharedPagination.propTypes = {
    uriRef: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    numberOfPages: PropTypes.number,
    maxItems: PropTypes.number,
    dataTn: PropTypes.string,
    totalPageLinks: PropTypes.number,
};

export { SbSharedPagination };
